<template>
     <div class="publicViewClass" style="padding-top:0" id="publicWaterMark">
       <div  class="app-inner">
        <div class="preview-nav flex align-cen">
            <div class="preview-nav-left flex align-cen">
                <i class="icon-al-exclamation-circle"></i>
                <span>提示：预览过程中只看效果，不保存数据</span>
            </div>
            <div class="mft">
                <div class="close" @click="$util.reback('/teacheManage/enTestPaper')">关闭</div>
            </div>
        </div>
        <div class="preview-content">
            <div class="new-content-panel" v-if="isShow == 1">
                <div class="title">
                    <img :src="ExamPreviewInfo.logo" alt="">
                </div>
                <div class="brand-info">
                    <div class="new-exam-title">
                        {{ExamPreviewInfo.paperName}}
                    </div>
                  <h4 v-if="ExamPreviewInfo.showGuidelines !=0">考试说明</h4>
                    <div class="user-introduce" v-html="ExamPreviewInfo.guidelines" v-if="ExamPreviewInfo.showGuidelines ==2 || ExamPreviewInfo.showGuidelines ==3">
                        
                    </div>
                </div>
                <ul class="system-introduce" v-if="ExamPreviewInfo.showGuidelines ==1 || ExamPreviewInfo.showGuidelines ==3">
                       <li>
                        <p class="flex align-cen">
                            <span>考试次数：</span>
                            <span class="mft">{{shouInfo(ExamPreviewInfo.answerNumType,ExamPreviewInfo.answerNum,1)}}</span>
                        </p>
                    </li>
                    <li>
                        <p class="flex align-cen">
                            <span>考试限时：</span>
                            <span class="mft">{{shouInfo(ExamPreviewInfo.answerTimeControl,'',2)}}</span>
                        </p>
                    </li>
                    <li>
                        <p class="flex align-cen">
                            <span>及格分数：</span>
                            <span class="mft">{{shouInfo(0,ExamPreviewInfo.passmark,3)}}</span>
                        </p>
                    </li>
                    <li>
                        <p class="flex align-cen">
                            <span>考试规则：</span>
                            <span class="mft">{{shouInfo(ExamPreviewInfo.allowBackChange,'',4)}}</span>
                        </p>
                    </li>
                    <li>
                        <p>
                            如果考试异常中断，请退出并及时按同样步骤进入，继续考试
                        </p>
                    </li>
                </ul>
                <div class="goToExam" @click="isShow = 2">
                    进入考试
                </div>
            </div>
             <div class="new-content-panel" v-if="isShow == 2">
                <div class="brand-info">
                    <div class="new-exam-title">
                        {{ExamPreviewInfo.paperName}}
                    </div>
                    <h4>请输入您的身份信息</h4>
                </div>
                <div class="form-group">
                    <div class="input-group flex align-cen">
                        <div class="label">账号</div>
                        <el-input placeholder="请输入您账号" v-model="account" clearable></el-input>
                    </div>
                    <div class="input-group flex align-cen">
                        <div class="label">密码</div>
                        <el-input placeholder="请输入您的账号密码" v-model="psw" clearable show-password></el-input>
                    </div>
                </div>
                  <div class="goToExam" style="margin-top:120px" @click="openListexams">
                    开始考试
                </div>
             </div>
             <div class="new-content-panel1 flex" v-if="isShow ==3" :loading="loading">
                <div class="exam-metas" v-if="sourceData.paper">
                    <div class="metas">
                        <p class="metas-p">{{sourceData.paper.paperName}}</p>
                        <div class="time-left">
                            <div class="time-main"  v-if="sourceData.paper.answerTimeControl == 1 || sourceData.paper.answerTimeControl == 2">
                                <strong>
                                    <span>
                                        <el-statistic :value="Date.now() + 1000 * 60 * sourceData.paper.answerTimeLimit" 
                                        time-indices
                                         format="HH:mm:ss"
                                           @finish="hilarity"
                                        >
                                            </el-statistic>
                                    </span>
                                </strong>
                            </div>
                               <div class="time-main"  v-if="sourceData.paper.answerTimeControl == 3">
                                <strong>
                                    <span>
                                        <el-statistic :value="Ddtime" 
                                        time-indices
                                         format="HH:mm:ss"
                                           @finish="hilarity"
                                           v-if="DdtimeS"
                                        >
                                            </el-statistic>
                                    </span>
                                </strong>
                            </div>
                            <div class="time-tip flex align-cen">
                                <span class="icon-al-clock"></span>
                                总剩余时间
                            </div>
                            <div class="page">总题数：{{sourceData.questionMapList.length}}</div>
                        </div>
                        <div class="questions-card">
                            <span>
                                <strong>题卡</strong>
                            </span>
                        </div>
                        <div class="questions-lists">
                            <div class="q-list">
                                <ul>
                                    <li v-for="(item,index) in sourceData.questionMapList" 
                                     :key="index" 
                                     :class="item.isAnswer == 1 ? 'Answeral' :''"
                                     @click="answerPublicFn(index)"
                                    >{{index + 1}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="metas-footer">
                            <div class="questipn-lists-icon flex align-cne">
                                <span class="allright flex align-cen">
                                    <i></i>
                                    已做
                                </span>
                                <span class="noright flex align-cen">
                                    <i></i>
                                    未做
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
               <div class="doexam-main publicScroolbar">
                   <div class="row">
                    <div class="question" v-if="questionDetailList.length" >
                        <div class="question-main-content" v-for="(item,index) in questionDetailList" :key="index">
                            <div class="ques-title flex">
                                <p class="ques-number">{{indexShow + 1}}.</p>
                                <p class="ques-type">[{{$util.getTopicType(item.type)}}]</p>
                                <p class="title-pre" v-html="item.title" :class="item.type == 9 ? 'clozeClass' : ''">
                                    <div class="clozeMask ques-answers" v-if="item.type == 9 && isCloze">
                                        <span class="icon-al-times-circle-fill clozecloze" @click.stop="isCloze = false"></span>
                                           <ul>
                                        <li  v-for="(sonitem,sonIndex) in item.answerList[clozeIndex1].clozeList" :key="sonIndex" 
                                        :class="getClass1(item,sonIndex)"
                                        @change="showChage(item.type,sonitem,sonIndex)"
                                        >
                                           <el-radio v-model="radio1" :label="sonIndex"
                                    class="flex align-cen"
                                     >
                                     <div class="flex align-cen">
                                        {{Eng[sonIndex]}}.<div v-html="sonitem.content"></div>
                                     </div>
                                     </el-radio> 
                                        </li>

                                    </ul>
                                    </div>
                               </p>
                                  <AudioTem :audioSrc="item.audio" v-if="item.audio"></AudioTem>
                                <p class="ques-score">（{{item.score}}分）</p>
                            </div>
                     <div class="ques-answers">
                           <ul v-if="item.type != 5 && item.type !=7 && item.type !=9">
                                <li v-for="(sonitem,sonIndex) in item.answerList" :key="sonIndex"
                                  :class="getClass(item,sonIndex,sonitem)"
                                >
                                     <el-radio v-model="radio" :label="sonIndex"
                                    @change="showChage(item.type)"
                                    class="flex align-cen"
                                    v-if="item.type == 1 || item.type ==3"
                                     >
                                     <div class="flex align-cen">
                                        {{Eng[sonIndex]}}.<div v-html="sonitem.content"></div>
                                     </div>
                                     </el-radio>   
                                      <el-checkbox-group v-model="checkList" v-if="item.type == 2 || item.type == 6"
                                        @change="showChage(item.type)"
                                      >
                                        <el-checkbox :label="Eng[sonIndex]" > <div class="flex align-cen">{{Eng[sonIndex]}}.<div v-html="sonitem.content"></div></div></el-checkbox>
                                    </el-checkbox-group>
                                    <div class="ipt-group flex align-cen" v-if="item.type == 4">
                                  
                                        <span>{{sonIndex + 1}}</span>
                                        <el-input  placeholder="填写答案" v-model="sonitem.content" clearable @input="showChage(item.type,sonitem.content,sonitem.id)">
                                        </el-input>
                                    </div>
                                </li>

                            </ul>
                                                 <div class="essayTxr" v-if="item.type == 5">
                                <el-input
                                    type="textarea"
                                    :rows="8"
                                    placeholder="请在这里输入答案"
                                    v-model="item.answerContent"
                                    @input="showChage(item,index,item.type)"
                                    show-word-limit
                                    maxlength="10000"
                                    >
                                    </el-input>
                            </div>
                             <div class="essayPx" v-if="item.type == 7">
                                   <div class="sortingquestion-option-container" id="sortAnswers">
                                    <div class="el__row"  v-for="(sonitem,sonIndex) in emptyList3Copy" :key="`sortAnswers${sonIndex}`">
                                    <div class="sortingquestion-option flex align-cen">
                                        <div class="sortingquestion-option-move">
                                        <span class="icon-al-menu handle_move"></span>
                                        </div>
                                        <div class="sortingquestion-option-text">
                                            <div class="title-pre">{{sonitem.content}}</div>
                                        </div>
                                    </div>
                                    </div>
                                 </div>
                             </div>
                              <div class="essayWx" v-if="item.type == 9">
                                <div class="ques-tips" style="font-size:16px;color:#aaa">(点击题目空格处，选择合适的答案完成作答)</div>
                              </div>
                        </div> 
                        </div>
                        <div class="downtip" v-if="showReminder">
                            <p class="num">{{countDown}}</p> 
                            <p>自动交卷倒计时</p>
                        </div>
                        <div class="submit-buttons flex align-cen">
                            <div class="backPage btn" v-if="indexShow!=0 && sourceData.paper.answerTimeControl !=3 && sourceData.paper.allowBackChange ==1" @click="answerPublicFn('prev')">上一题</div>
                            <div class="nextPage btn" @click="answerPublicFn('next',)" v-if="indexShow != sourceData.questionMapList.length - 1">下一题</div>
                            <div class="nextPage btn"  v-if="indexShow == sourceData.questionMapList.length - 1 || ishandPaper" @click="handPaper">交卷</div>
                        </div>
                    </div>
                   </div>
                </div>
             </div>
              <div class="new-content-panel" v-if="isShow == 4">
                <div class="brand-info">
                    <div class="new-exam-title">
                        {{ExamPreviewInfo.paperName}}
                    </div>
                </div>
                <div class="tabbable">
                    <el-tabs  v-model="activeName">
                    <el-tab-pane label="本次成绩" name="1">
                        <div class="tester-info">
                    <p class="text">考试者：预览</p>
                    <p class="lastP">
                        开始时间：{{this.$util.getTimeData(0)}} | 交卷时间：{{this.$util.getTimeData(0)}} 
                    </p>
                     <div class="sorceRow">
                        <div class="result-scores">
                            <div class="exam-record-info">
                                <p class="score-num">0
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf">(总分100分)</div>
                             <div class="zf">用时：30分钟</div>
                             <!-- <div class="exam-record-info">
                                <p class="score-num">
                                    <el-progress type="circle" :percentage="format1"  :color="'#e73a30'" :format="format"></el-progress>
                                    <p>分数</p>
                                </p>
                            </div>
                             <div class="exam-record-info">
                                <p class="score-num">{{convertSecondsToMinutes(testerInfo.doTime,2)}}</p>
                                <p class="score-tit">用时</p>
                            </div> -->
                        </div>
                    </div>
                </div>
                    </el-tab-pane>
                    <el-tab-pane label="答题分析" name="2">
                         <div class="print-tab-content">
                            预览时无答题分析
                         </div>
                    </el-tab-pane>
                    </el-tabs>
                </div>
              </div>
        </div>
       </div>
         <previewTem :paperJson="ExamPreviewInfo"></previewTem>
    </div>
</template>
<script>
import {paperExam} from "@/api/enterprise/index"  //考试查询试卷息
import WaterMark from '@/utils/waterMark.js'
import mycomponents from "@/utils/compoments.js";
import Sortable from "sortablejs";
// import { connectWebsocket, closeWebsocket } from "@/utils/socket.js";
export default {
    name: "ExamPreview",
      components: {
         AudioTem: mycomponents.components.PublicAudio,
         previewTem:mycomponents.components.previewType
    },
    data() {
        return {
            adio1:null,
            isCloze:false,
            clozeIndex:0,
            clozeIndex1:0,
            clozeList:[],
             sortable:null,
            emptyList3Copy:[],
            emptyList3:[],
            wordCount:0,
            waterMark:null,
             countDown1:'',
            qzjj:false,
            indices:[],
            encryptQuery:'',
            transcript:'',
            DdtimeS:false,
            Ddtime:'',
            activeName:'1',
            ishandPaper:false,
            isclose:true,
            inputArr:[],
            checkList:[],
             deadline:'',
        showReminder:false,
            loading:false,
            psw:'',
            account:'',
            indextype:'',
            isShow:1,
            ExamPreviewInfo:{},
             indexShow:'',
            tes:[],
            deadline2: Date.now() + 1000 * 60 * 30,
            radio:'-1',
            wsUrl: "",//定义socket连接地址
            sourceData:{},
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            questionDetailList:[],
             countDown: '', // 倒计时时间
            timer: null // 定时器
        }
    },
   destroyed() {
     //在离开此页面的时候主动关闭socket
         this.$socketApi.closeWebsocket()
         clearInterval(this.timer);
          this.hidden()
  },
    created() {
     this.getPaperExam()
    },
    mounted () {
      window.addEventListener("beforeunload", this.hidden);  
    }, 
     methods: {
                       // 根据条件显示不同
        shouInfo(type,num,fnType){
            // fnType = 1 表示考试次数、 2、表示考试限时、3、及格分数，4、考试股则
            const actionTypelanes = {
                0:fnType == 1 ? '无限次': fnType == 3 ? `${num}%`: '-',
                1:fnType == 1 ? '一次' : fnType == 2 ? `${this.ExamPreviewInfo.answerTimeLimit}分钟` : fnType == 4 ? '允许考生返回修改答案' : '',
                2:fnType == 1 ? `多次（${num}次）` : fnType == 2 ? '' : '',
                3:fnType == 1 ? `每天每人（${num}）次` : fnType == 2 ? `单题${this.ExamPreviewInfo.singleDuration}分钟` : '',
                4:fnType == 1 ? '' : fnType == 2 ? '填空题' : ''
            }
            return actionTypelanes[type] || '-'
        },
            // 设置水印
    showMark() {
      this.waterMark = new WaterMark({
        watermark_txt: '和隆优化', // 水印的内容
        watermark_x: 0, // 水印起始位置x轴坐标
        watermark_y: 0, // 水印起始位置Y轴坐标
        watermark_rows: 0, // 水印行数
        watermark_cols: 0, // 水印列数
        watermark_x_space: 50, // 水印x轴间隔
        watermark_y_space: 250, // 水印y轴间隔
        watermark_width: 350, // 水印宽度
        watermark_height: 50, // 水印长度
        watermark_angle: 35, // 水印倾斜度数
        monitor: false,
      });
    },
    // 隐藏水印
    hidden() {
      if (this.waterMark) {
        this.waterMark.remove()
      }
    },
    getClass1(data,index){
        if(this.radio1 == index) {
                return 'liActive'
            }
      },
      handPaper(){   
            if(this.sourceData.paper.answerTimeControl != 3){
            // 时间为独立或者动态时间
            if( this.sourceData.paper.mandatory.includes('1')){
            // 必须回答完所有试题交卷
            let arr = this.sourceData.questionMapList
            let nullLen = []
            for (const key in arr) {
              if(arr[key].isAnswer == 0){
              nullLen.push(arr[key])
              }
            }
            if(nullLen.length){
                return this.$util.Notifi(`还有${nullLen.length}道题未做，请先做完试题`,'error','fa-exclamation-circle');
            }
            }
            }
                this.isShow = 4 
        },
        // 交卷
    //     handPaper(){
    //         if(this.sourceData.paper.answerTimeControl != 3 || this.sourceData.paper.mandatory.includes('1')){
    //   let arr = this.sourceData.questionMapList
        
    //         let nullLen = []
    //         for (const key in arr) {
    //           if(!arr[key].isAnswer || arr[key].isAnswer == 0){
    //           nullLen.push(arr[key])
    //           }
    //         }
    //             console.log(nullLen)
    //         if(nullLen.length){
    //             this.$util.Notifi(`还有${nullLen.length}道题未做，请先做完试题`,'error','fa-exclamation-circle');
    //         }else{
                
    //            this.isShow = 4
    //         }
    //         }else{
    //            this.isShow = 4 
    //         }
    //     },
        // 下一题
        answerPublicFn(type){
            this.loading = true
            if(type == 'next'){
                this.indexShow = this.indexShow + 1
                if(this.sourceData.paper.answerTimeControl == 3){
                this.DdtimeS = false
                this.Ddtime = Date.now() + 1000 * 60 * this.sourceData.paper.singleDuration
            }
            }else if(type == 'prev'){
                this.indexShow = this.indexShow - 1
                if(this.indexShow < 0){
                    this.indexShow = 0 
                }
            }else{
                 if(this.sourceData.paper.answerTimeControl !=3 && this.sourceData.paper.allowBackChange == 1){
                    this.indexShow = type 
                 }else{
                    return
                 }
                
            }
            this.questionDetailList = []
            this.radio = '-1'
            this.checkList = []
            this.inputArr = []
            this.indices = []
             let params = {
                type:'questionDetail',
                questionIds:this.sourceData.questionMapList[this.indexShow].questionId.split(',')
            }
            this.$socketApi.onWsOpen(params)
        },
                   // 动态添加class
    getClass(data,index,item){
        if(data.type == 1 || data.type == 3){
            if(this.radio == index) {
                return 'liActive'
            }
        }else if(data.type == 2){
            if(this.indices[index] == index){
                return 'liActive'
            }
        }else if(data.type == 4){
            if(item.content){
                return 'liActive'
            }
        }
    },
         showChage(type,content,id){
            this.indextype = type
            this.sourceData.questionMapList[this.indexShow].isAnswer = 1
            if(type == 9){
               
                this.clozeList[this.clozeIndex1] = this.Eng[id]
                 // 找到所有带 clickable 类的 span 元素，并为它们添加点击事件监听器  
            let  clickableSpans1 = this.$el.querySelectorAll('.clickable');  
                    clickableSpans1[this.clozeIndex1].innerHTML = `<span style="color: #36aafd;text-decoration: #36aafd underline">${content.content}</span>`;
                    }else if(type == 4){
                  let a = this.questionDetailList
                    let ar
                 for (const key in a) {
                    this.inputArr = a[key].answerList
                  if(a[key].answerList.every(item => !item.content)){
                     this.sourceData.questionMapList[this.indexShow].isAnswer = 0
                     delete this.sourceData.questionMapList[this.indexShow]['checkId'] 
                  }else{
                     this.sourceData.questionMapList[this.indexShow].isAnswer = 1
                      this.sourceData.questionMapList[this.indexShow].checkId = this.inputArr
                  }
                }
            }else if(type == 2){
               
                this.indices = this.checkList.map((item, index) => this.Eng.indexOf(item));
                if(!this.checkList.length){
                     this.sourceData.questionMapList[this.indexShow].isAnswer = 0
                    delete this.sourceData.questionMapList[this.indexShow]['checkId'] 
                }else{
                  this.sourceData.questionMapList[this.indexShow].isAnswer = 1   
                  this.sourceData.questionMapList[this.indexShow].checkId = this.checkList
                }
            }else{
                this.sourceData.questionMapList[this.indexShow].isAnswer = 1
                 this.sourceData.questionMapList[this.indexShow].checkId = this.radio
            }
        },
                // 进入考试
        openListexams(){
            this.isShow = 3
            this.loading = true
            this.webSocketData('');
             this.indexShow = 0
        },
        getPaperExam(){
            paperExam({id:this.$route.query.id,view:'preview'}).then(res=>{
               this.ExamPreviewInfo = res.data
            })
        },
          // 倒计时结束
        hilarity(){
        this.$notify.error({
          title: "温馨提示",
          message: "时间已到，交卷中，请勿刷新页面",
          duration: 2000,
        });
        this.isShow = 4
        },
             webSocketData(questionId){
            this.loading = true
              let socketUrl = ''
            if(this.$config.baseUrl.includes('http://')){
                 socketUrl = this.$config.baseUrl.replace('http://', ''); 
            }else{
                 socketUrl = this.$config.baseUrl.replace('https://', ''); 
            }
            let wsUrl = `ws://${socketUrl}/exam/ws/${this.$route.query.id}?token=&businessId=&view=preview`
            let params = {
                type:'questionDetail',
                questionIds:[]
            }
            this.$socketApi.connectWebsocket(wsUrl,params,(res) => {
                    let datas = JSON.parse(res)
                    this.loading = false
                  if(datas.code == 0 ){
                    if(datas.data.paper){
                          this.sourceData = datas.data
                           if(this.sourceData.paper.watermark == 1){
                             this.showMark()
                          }
                         //   为独立时间时
                          if(datas.data.paper.answerTimeControl == 1 || datas.data.paper.answerTimeControl == 2){
                              this.deadline = Date.now() + 1000 * 60 * datas.data.paper.answerTimeLimit
                          this.countDown = Number((datas.data.paper.answerTimeLimit * 60) - 1)
                           this.startCountDown()
                          }
                            if(!this.sourceData.paper.allowBackChange){
                             this.$util.Notifi('此试卷已设置不允许返回修改答案，请您认真回答提交每一题','error','fa-exclamation-circle') 
                          }
                          params.questionIds = []
                          params.questionIds.push(datas.data.questionMapList[0].questionId) 
                          this.$socketApi.onWsOpen(params)
                    }else if(this.questionDetailList){
                        if(this.sourceData.paper.answerTimeControl == 3){
                            this.DdtimeS = true
                            this.Ddtime = Date.now() + 1000 * 60 * this.sourceData.paper.singleDuration
                        }
                        this.questionDetailList = datas.data.questionDetailList
                    }
                 if(this.questionDetailList.length){
                let a = this.questionDetailList
                for (const key in a) {
                       // 单选或者判断题
                        if(a[key].type == 1 || a[key].type == 3){
                    //   this.radio = this.sourceData.questionMapList[this.indexShow].checkId
                     if(this.sourceData.questionMapList[this.indexShow].checkId){
                                    this.radio = this.sourceData.questionMapList[this.indexShow].checkId
                                }else if(this.sourceData.questionMapList[this.indexShow].checkId == 0){
                                    this.radio = 0
                                }else{
                                    this.radio = '-1'
                                }
                        }else if(a[key].type == 2 || a[key].type == 6){
                             // 多选题

                             let typeDx = this.sourceData.questionMapList[this.indexShow].checkId
                             if(typeDx && typeDx.length){
                                this.checkList = typeDx
                                 this.indices = this.checkList.map((item, index) => this.Eng.indexOf(item));
                             }                                        
                             
                        }else if(a[key].type == 7){
                                this.emptyList3 = a[key].answerList
                                let a1 = a[key].answerList
                                let b = []
                                let c = []
                                if(a[key].answerContent){
                                    b = a[key].answerContent.split(',')
                                    let indices = b.map(element => {  
                                        return this.Eng.indexOf(element);  
                                    }); 
                                  indices.forEach(index => {  
                                    // 确保索引在a数组的有效范围内  
                                        if (index >= 0 && index < a1.length) {  
                                            c.push(a1[index]);  
                                        }  
                                    });
                                    this.emptyList3Copy = [...c]
                                }else{
                                    this.emptyList3Copy = [...a[key].answerList]
                                }
                               
                             this.$nextTick(() => {
                                    this.init()
                                })
                            }else if(a[key].type == 9){
                             this.clozeList = a[key].answerContent ? a[key].answerContent.split(',') : []  
                            a[key].answerList.forEach((t,index) => {
                                let patternString = `{{${index + 1}}}`;
                                a[key].title = a[key].title.replace(patternString, `<span class="clickable" data_type="${key}" data_type2="${index}" style="color: rgb(54, 170, 253);cursor: pointer;">______</span>`)
                                     this.$nextTick(() => {
                                      if(this.clozeList.length){
                                          let a2 =  a[key].answerList[index].clozeList
                                       let  clickableSpans1 = this.$el.querySelectorAll('.clickable');  
                                        let arrindex = this.Eng.indexOf(this.clozeList[index]);
                                         clickableSpans1[index].innerHTML = `<span style="color: #36aafd;text-decoration: #36aafd underline">${a2[arrindex].content}</span>`;
                                      }
                                  this.addClickableListeners(); 
                                })
                                  
                            })  
                            }
                    for (const iterator in a[key].answerList) {
                    if(a[key].type == 4){
                            let b = this.sourceData.questionMapList[this.indexShow].checkId
                            if(b && b.length){
                                for (const i in b) {                                    
                           if(a[key].answerList[iterator].id == b[i].id){ 
                              a[key].answerList[iterator].content = b[i].content  
                           }                                                                
                                }
                            }                                                                           
                        }
                            
                    } 
                }
            }
                  }else{
                     this.$util.Notifi(datas.msg,'error','fa-exclamation-circle')
                         setTimeout(() => {
					    this.$util.reback('/teacheManage/enTestPaper')
                        },1000);
                   
                  }
                    },
                    () => {
                        this.loading = false
                        console.log("失败的回调函数");
                    }
                    );
        },
                                         	init(){                               
                                // console.log(this.emptyList3Copy)
		// 1. 获取拖拽元素的父元素
		// 因为使用的element的table 所以可直接获取tbody
		let el =  document.getElementById("sortAnswers");
		let that = this;	
		// 2. 创建并配置相关参数
		 this.sortable = new Sortable(el, {			
			// 只有按住手柄才能进行拖拽
            handle:'.handle_move',
			// 行拖拽，所以该值设置为行class            
			// 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
      draggable:'.el__row', // 允许拖拽的项目类名	
		// 拖拽结束，调整位置
			onEnd(event) {
              let oldIndex = event.oldIndex;
                let newIndex = event.newIndex;  
                 let temp = that.emptyList3Copy[oldIndex];
                 if(oldIndex < newIndex){
                      for(var i = oldIndex ; i < newIndex ; i++){
                        that.emptyList3Copy[i] = that.emptyList3Copy[i+1];
                    }
              }
              if(oldIndex > newIndex){
                for(var i = oldIndex ; i > newIndex ; i--){
                        that.emptyList3Copy[i] = that.emptyList3Copy[i-1];
                    }
              }
             
              that.emptyList3Copy[newIndex] = temp;    
             let b = that.emptyList3Copy
              let a = that.emptyList3
             // 创建一个空数组来存储b中每个对象在a中的索引  
            let indices = b.map(objB => {  
                // 使用findIndex找到objB在a中的索引，基于isRight属性相等  
                return a.findIndex(objA => objA.isRight === objB.isRight);  
            });
                    let result =  indices.map(index => that.Eng[index]);
                      that.resultQuestions = [
                        {
                            questionId: that.emptyList3Copy[newIndex].questionId,
                            answerContent:result.join(',')
                        }
                        ] 
                        that.sourceData.questionMapList[that.indexShow].isAnswer = 1            
	        },
		})
	},   
  addClickableListeners() {  
      // 找到所有带 clickable 类的 span 元素，并为它们添加点击事件监听器  
      const clickableSpans = this.$el.querySelectorAll('.clickable');  
      clickableSpans.forEach((span) => {  
        span.addEventListener('click', (event) => {  
          // 获取自定义属性的值  
          const dataType = span.getAttribute('data_type');  
          const dataType2 = span.getAttribute('data_type2');  
          // 调用 Vue 方法处理点击事件  
          this.openRa(dataType, dataType2);  
        });  
      });  
    },
    // 
    openRa(index1,index2){
        if(this.clozeList[index2]){
            let str = this.clozeList[index2]
            let arrindex = this.Eng.indexOf(str);
            this.radio1 = arrindex
        }else{
             this.radio1 = '-1'
        }  
        this.clozeIndex = index1
        this.clozeIndex1 = index2
        this.isCloze = true
    },
         startCountDown() {
                        this.timer = setInterval(() => {
                        if (this.countDown > 0) {
                        this.countDown--;
                        if(this.countDown == 5){
                            this.showReminder = true
                        }
                        } else {
                            this.showReminder = false
                        clearInterval(this.timer);
                        }
                        }, 1000);
                        },
    }
}
</script>
<style lang="scss" scoped>
   .clozeMask{
        position: absolute;
        background: #fff;
        left: 150px;
        top: 30px;
        min-width: 200px;
        box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
        background: #fff;
        padding: 20px;
        border: 1px solid #eee;
        border-radius: 5px;
        .clozecloze{
                display: block;
                position: absolute;
                right: 5px;
                top: -2px;
                cursor: pointer;
        }
       }
  .sortingquestion-option-container{
    .el__row{
      margin-bottom: 20px;
      .sortingquestion-option{
        position: relative;
       .sortingquestion-option-move{
        text-align: center;
            width: 36px;
            height: 36px;
            background-color: #f3f3f3;
           
            border: solid 1px #ccc;
            cursor: grab;
            line-height: 34px;
            box-sizing: border-box;
            span{
              font-size: 18px;
              color: #999;
              vertical-align: middle;
              transform: translateY(50%);
            }
       }
       .sortingquestion-option-text{
        width: 80%;
       }
    
        .title-pre{
                position: relative;
    height: 36px;
    line-height: 36px;
    border: 1px solid #e5e3e2;
    border-left: none;
    background: #fff;
    padding-left: 30px;
    box-sizing: border-box;
        }
       .edit-btn-group{
        font-size: 18px;
        color: red;
        margin-left: 30px;
        margin-right: 30px;
        cursor: pointer;
       }
      }
    }
  }
.publicViewClass{
    height: 100vh;
}
.tabbable{
    margin-top: 50px;
        .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
.downtip{
    position: absolute;
    width: 250px;
    height: 150px;
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    text-align: center;
    .num{
        color: red;
        font-size: 34px;
        padding-top: 20px;
        padding-bottom: 10px;
    }
}
.app-inner{
    
   background:#f7f8fa ;
   box-shadow: 0px 1px 6px 0px rgba(11, 34, 51, 0.1);
      border-radius: 10px;
   .preview-nav{
     background:#fff ;
     margin-left: -16px;
     margin-top: -16px;
     width: calc(100% + 32px);
    border-radius: 10px 10px 0 0;
    padding-bottom: 16px;
    padding-top: 16px;
    .preview-nav-left{
        padding-left: 2%;
        margin-top: 10px;
        width: 350px;
        i{
            color: red;
            font-size: 20px;
        }
        span{
            font-size: 16px;
            color: red;
            margin-left: 1%;
        }
    }
    .mft{
        margin-right: 20px;
        .close{
            width: 74px;
    height: 42px;
    border-radius: 4px!important;
    border: solid 1px #e6e6e6;
    text-align: center;
    cursor: pointer;
    line-height: 42px;
        }
    }
   }
   .preview-content{
    .new-content-panel{
    width: 600px;
    margin: 70px auto 0;
    float: none;
    display: table;
    position: relative;
    text-align: center;
    min-height: 660px;
    background: #fff;
    padding: 30px;
    padding-top: 20px;
    padding-bottom: 15px;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
    .form-group{
        .input-group{
            padding: 0 70px;
            margin-bottom: 40px;
            .label{
              border: none;
              width: 80px;
            text-align: left;
            font-size: 16px;
            color: #666;  
            }
            .el-input{
                margin-left: 10px;
            }
        }
    }
    .title{
       padding-bottom: 40px;
        margin-top: 40px;
        border-bottom: 1px solid #e6e6e6;
        text-align: center; 
        img{
            max-height: 100px;
            max-width: 550px;
        }
    }
    .brand-info{
        text-align: center;
        .new-exam-title{
       margin-top: 30px;
        font-size: 22px;
        color: #36aafd!important;
        }
        h4{
            margin: 35px 0 45px;
            color: #555;
            font-size: 18px;
            font-weight: 400;
        }
    }
    .system-introduce{
    list-style: none;
    padding: 0;
    margin: 10px auto 50px;
    max-width: 388px;
    li{
     overflow: hidden;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 5px;
    padding-top: 5px;
    font-size: 16px;
    color: #666;
    text-align: left;
    span{
        margin-top: 3px;
        color: #333;
        font-size: 16px;
    }
    }
    }
    .goToExam{
        width: 250px;
        margin-bottom: 20px;
    color: #fff;
    background-color: #36aafd;
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: #36aafd;
    border-radius: 2px;
        display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    }
    }
    .new-content-panel1{
    margin-right: auto;
    margin-left: auto;
    margin-top: 70px;
    width: 970px;
    border-radius: 5px;
    height: 715px;
    position: absolute;
    padding-bottom: 50px;
    left: 45%;
    transform: translateX(-50%);
    .exam-metas{
        width: 210px;
            background: #fff;
        .metas{
    position: relative;
    padding: 0 10px;
    background-color: #fff;
    margin-bottom: 13px;
    text-align: center;
    height: 100%;
    .metas-p{
     padding-top: 11px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    }
    .time-left{
       margin: 21px 0 10px;
       border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
       .time-main{
        margin-top: 11px;
        span{
           font-size: 34px;
            color: #36aafd;
            font-weight: 400; 
        }
       }
       .time-tip{
        color: #666;
        font-size: 16px;
        justify-content: center;
    span{
        color: #36aafd;
        font-size: 20px;
    }
       }
       .page{
            margin: 25px 0;
    font-size: 16px;
    color: #333;
    padding: 5px 0;
       }
    }
    .questions-card{
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 5px;
    }
    .questions-lists{
     max-height: 290px;
    overflow-y: auto;
    margin-bottom: 10px;
    padding-right: 0; 
    padding: 10px;
    .q-list{
      ul{
         display: flex;
            flex-wrap: wrap;
        li{
           font-size: 12px;
    display: block;
    padding: 2px 0;
    border: 1px solid #bbb;
    border-radius: 2px;
    margin-right: 9px;
    margin-bottom: 9px;
    min-width: 25px;
    color: #666;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
        }
        .Answeral{
            background: #36aafd;
            color: #fff;
            border: none;
        }
        li:hover{
            background: #36aafd;
            color: #fff;
            border: none;
        }
      }
    }
    }
    .metas-footer{
        margin-top: 20px;
    .questipn-lists-icon{
        justify-content: center;
        span{
            margin-bottom: 10px;
            color: #aaa;
            margin-right: 10px;
        }
                   .allright{
              i{
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 5px;
                background: #36aafd;
               margin-right: 5px;
              }
            }
            .noright{
                i{
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 5px;
               border: 1px solid #aaa;
               box-sizing: border-box;
                margin-right: 5px;
                }
            }
    }
    }
        }
    }
    .doexam-main{ 
    background-color: #fff;
    margin: 0 15px;
    flex-grow: 1;
    overflow: hidden;
    overflow-y: auto;
    width: calc(100% - 210px);
    .question{
        padding: 0 15px;
        position: relative;
        .question-main-content{
            margin-top: 15px;
         margin-bottom: 15px;
         .ques-title{
            font-size: 16px;
            line-height: 30px;
            hyphens: auto;
            -ms-hyphens: auto;
            text-align: justify;
            .ques-number{
                line-height: 27px;
                color: #36aafd;
                border-color: #36aafd;
                padding-top: 2px;
                margin-right: 3px;
            }
           .ques-type{
                 margin-right: 10px;
                vertical-align: middle;
                color: #36aafd;
                min-width:60px ;
                }
                                .title-pre{
                    white-space: normal!important;
                }
                .ques-score{
                    color: #aeaeae;
                    min-width: 60px;
                }
         }
                .ques-answers{
            margin-top: 15px;
            ul{
                li{
                    font-size: 14px;
                        white-space: normal;
                        background-color: #fff;
                        border-color: #eaeaea;
                        text-align: left;
                        margin-bottom: 10px;
                        padding: 10px 12px;
                        font-weight: 400;
                        line-height: 1.42857143;
                        white-space: nowrap;
                        vertical-align: middle; 
                        -ms-touch-action: manipulation;
                        touch-action: manipulation;
                        cursor: pointer;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        background-image: none;
                        border: 1px solid #eaeaea;
                        border-radius: 4px;
                }
                li:hover{
                    background-color: #fff;
                border-color: #009aff;
                }
                .liActive{
                  border: 2px solid #009aff;
                }
            }
         }
        }
    }
    .submit-buttons{
    background-color: #fff;
    padding: 40px 80px 50px;
    margin-bottom: 0;
    margin-top: 100px;
    .btn{
    padding: 10px 0;  
    flex-grow: 1;
        background: #fff;
        margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border-radius: 4px;
    margin-right: 10px;
    }
    .backPage{
    color: #36aafd;
     border: 1px solid #36aafd;
    }
    .nextPage{
    color: #fff;
    background-color: #36aafd;
    border: none;
    }
    }
    }
    }
   }
}
::v-deep{
    .el-statistic{
    font-weight: 400;
    .number{
    font-size: 34px;
    color: #36aafd;
    }
    }
    .ipt-group{
        .el-input{
            width: 200px;
            .el-input__inner{
                border: none;
                border-bottom: 1px solid #DCDFE6;
                border-radius: 0;
                margin-left: 10px;
            }
        }
    }
       .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>